import React, { useState, useEffect } from "react"; // ✅ ADD useEffect import
import { AlertCircle, AlertTriangle } from "lucide-react";
import { standardizeIssue, autoGenerateIssue } from "../../api"; // Adjust the path if needed
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

export const IssueItem = ({
  type,
  title,
  description,
  issue,
  uploadId,
  utilityId,
  tableComponent,
}) => {
  const [showPreview, setShowPreview] = useState(false);
  const remoteUtilityId = useRemoteUtilityId();

  // Local state to manage visibility of buttons
  const [isStandardized, setIsStandardized] = useState(
    issue.isStandardizeFormat
  );
  const [isAutoGenerated, setIsAutoGenerated] = useState(
    issue.isNumFormatConfigured
  );
  const [isConfigureVisible, setIsConfigureVisible] = useState(
    issue.isConfigureGenerate
  );

  // ✅ ADD THIS: Sync local state with props when they change (after Fix All)
  useEffect(() => {
    setIsStandardized(issue.isStandardizeFormat);
    setIsAutoGenerated(issue.isNumFormatConfigured);
    setIsConfigureVisible(issue.isConfigureGenerate);
  }, [
    issue.isStandardizeFormat,
    issue.isNumFormatConfigured,
    issue.isConfigureGenerate,
  ]);

  const handleStandardize = async () => {
    try {
      await standardizeIssue(uploadId, issue, remoteUtilityId);
      setIsStandardized(false); // Hide the button after success
    } catch (error) {
      toast({
        title: `Standardize failed, ${error}`,
        description: ``,
      });
    }
  };

  const handleAutoGenerate = async () => {
    try {
      await autoGenerateIssue(uploadId, issue, remoteUtilityId);
      setIsAutoGenerated(false); // Hide the button after success
    } catch (error) {
      toast({
        title: `Auto-generate failed:", ${error}`,
        description: ``,
      });
    }
  };

  const handleConfigure = () => {
    toast({
      title: `Configure logic not implemented yet`,
      description: ``,
    });
    setIsConfigureVisible(false); // Hide on click
  };

  const Icon = type === "error" ? AlertCircle : AlertTriangle;

  // Check if any action buttons are visible
  const hasActionButtons =
    isAutoGenerated || isConfigureVisible || isStandardized;

  return (
    <div className="py-4 space-y-4">
      <div className="flex items-start space-x-3">
        <div
          className={`mt-1 ${
            type === "error" ? "text-red-500" : "text-yellow-500"
          }`}
        >
          <Icon size={20} />
        </div>
        <div className="flex-1 overflow-x-auto">
          <h4 className="font-medium text-gray-900 mb-1">{title}</h4>
          <p className="text-sm text-gray-600 mb-3">{description}</p>

          <div className="flex flex-wrap gap-2 mb-3">
            {isAutoGenerated && (
              <button
                className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition-colors"
                onClick={handleAutoGenerate}
              >
                Auto Generate
              </button>
            )}

            {isConfigureVisible && (
              <button
                className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition-colors"
                onClick={handleConfigure}
              >
                Configure & Generate
              </button>
            )}

            {isStandardized && (
              <button
                className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition-colors"
                onClick={handleStandardize}
              >
                Standardize Format
              </button>
            )}

            {/* ✅ ADD THIS: Show success status when no action buttons are visible */}
            {!hasActionButtons && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                ✓ Issue Resolved
              </span>
            )}

            <button
              className="text-blue-600 underline text-sm hover:text-blue-800 transition-colors"
              onClick={() => setShowPreview(!showPreview)}
            >
              {showPreview ? "Hide Records" : "View Records"}
            </button>
          </div>

          {showPreview && tableComponent}
        </div>
      </div>
    </div>
  );
};
